module.exports = __webpack_public_path__ + "img/icons-redbook.34c4b011.png";